(function () {

    a3_cabin_reports.directive('memosByCategory', memosByCategory);

    /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name memosByCategory
   * @restrict E
   * @description
   *   Implementation of memosByCategory
   *   Initialize the panels with memos group by category.
   * @example
   *   Usage:
   *   <memos-by-category Type="Flight/F , Ground/G, Duty/D" Id="FlightId, GroundId, DutyNo" Day="DutyDay"></memos-by-category>
   * @ngInject
   */
    function memosByCategory(MemoFactory, MemoImagesFactory, $uibModal, DataCleanerFactory, GroundDutyFactory, FlightFactory) {
        function link($scope, attrs) {
            $scope.togglePanel = togglePanel;
            var Id = $scope.id;
           

            /**
             * toggle Panel
             * @memberof memosByCategory
             * @param {number} panelId
             */
            function togglePanel(panelId) {
                $('#' + panelId).toggle();
            }

            //Initialize Memos
            if($scope.type == "duty" || $scope.type == "d"){
                MemoFactory.getMemosForCrewRoute(Id, $scope.day, function (results) {
                    $scope.memos = filterMemos(results);
                });
            }
            else if($scope.type == "ground" || $scope.type == "g"){
                MemoFactory.getMemosForGroundDuty(Id, function (results) {
                    $scope.memos = filterMemos(results);
                });
            }
            //(attrs.type == "flight" || attrs.type == "f") default Flight type
            else{
                MemoFactory.getMemosForFlight(Id, function (results) {
                    $scope.memos = filterMemos(results);
                });
            }
             
            /**
             * filter memos
             * @memberof memosByCategory
             * @param {object} data
             */
            function filterMemos(data){
                //normalize memos
                var distinctMemos = normalizeMemos(data);

                if (distinctMemos.length != data.length) {
                    MemoFactory.getMemosFromStorage(function (allMemos) {
                        var distinctMemosAll = normalizeMemos(allMemos);
                        MemoImagesFactory.getMemoImagesFromStorage(function (allMemoImages) {
                            var distinctMemoImagesAll = normalizeMemoImages(allMemoImages);
                            recreateIndexedDB(distinctMemosAll, allMemoImages);
                        });
                    });
                }
                var memosByCategory = [];
                for (var i = 0; i < distinctMemos.length; i++) {
                    var memo = distinctMemos[i];
                    if (!memosByCategory.filter(function (e) { return ( e.CategoryId != undefined && e.CategoryId == memo.CategoryId) || (e.Category != undefined && memo.Category == e.Category) }).length > 0) {
                        memosByCategory.push({ CategoryId: memo.CategoryId, Category: memo.Category, memoList: [memo] });
                    }
                    else if (memosByCategory.filter(function (e) { return ( e.CategoryId != undefined && e.CategoryId == memo.CategoryId) || (e.Category != undefined && memo.Category == e.Category) }).length > 0) {
                        memosByCategory.filter(function (object) {

                            if (( object.CategoryId != undefined && object.CategoryId == memo.CategoryId) || (object.Category != undefined && memo.Category == object.Category)) {
                                return object;
                            };
                        })[0].memoList.push(memo);
                    }
                }
                return memosByCategory;
            }
            function recreateIndexedDB(distinctMemosAll, distinctMemosImagesAll) {
                //delete indexdb
                var q = DataCleanerFactory.deleteIndexedDB();
                q.then(function () {
                    MemoFactory.setMemosToStorage(distinctMemosAll);
                    MemoImagesFactory.setMemoImagesToStorage(distinctMemosImagesAll);

                    //save normalize data to indexedDB
                    LogService.debug("Recreated IndexedDB");
                });
                q.catch(function (ex) {
                    console.log(ex);
                });

            }
            function normalizeMemos(data) {
                var distinctData = [];
                if (data && data.length > 1) {
                    var sortData = data.dynamicSort("Id");
                    for (var i = 0; i < sortData.length - 1; i++) {
                        if (sortData[i + 1].Id == sortData[i].Id) {
                            //swap rows in  list - check lastUpdated property, latest at the end
                            if (sortData[i].LastUpdated && sortData[i + 1].LastUpdated) {
                                var memoDateA = new Date(sortData[i].LastUpdated);
                                var memoDateB = new Date(sortData[i + 1].LastUpdated);
                                if (memoDateA.getTime() > memoDateB.getTime()) {
                                    var temp = sortData[i + 1];
                                    sortData[i + 1] = sortData[i];
                                    sortData[i] = temp;
                                }
                            }
                        } else {
                            distinctData.push(sortData[i]);
                        }
                    }
                    distinctData.push(sortData[sortData.length - 1]);
                } else {
                    distinctData = data;
                }

                return distinctData
            }
            function normalizeMemoImages(data) {
                var distinctData = [];
                if (data && data.length > 1) {
                    var sortData = data.dynamicSort("imageId");
                    for (var i = 0; i < sortData.length - 1; i++) {
                        if (!(sortData[i + 1].imageId == sortData[i].imageId)) {
                            distinctData.push(sortData[i]);
                        }
                    }
                    distinctData.push(sortData[sortData.length - 1]);
                } else {
                    distinctData = data;
                }

                return distinctData
            }

            $scope.openMemo = openMemo;


            /**
             * Open modal to see information for the selected Memo
             * @memberof memosByCategory
             * @param {object} memo A memo object
             */
            function openMemo(memo) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgMemo.html',
                    controller: 'MemoModalCtrl',
                    size: 'lg',
                    keyboard: false,
                    resolve: {
                        memo: function () {
                            return memo;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    if (memo.ReadDt == null) {
                        memo.ReadDt = new Date();
                        MemoFactory.saveOneMemoToStorage(memo);

                        if($scope.type == "ground"){
                            MemoFactory.markGroundDutiesUnread();
                        }
                    }
                });
            }
        }

        return {
            restrict: 'E',
            templateUrl: "views/directives/memosByCategoryPanel.tpl.html",
            scope: {
                type: '@',
                id: '=',
                day: '=' 
            },
            terminal: true,
            link: link
        }
    }
})();
